import React, { useEffect, useState } from 'react';
import { Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import OrganizationForm from '../components/OrganizationForm';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import { useMutateOrganizationHandler } from '../dataHandlers/mutateOrganizationHandler';

const OrganizationCreatePage = () => {
  useDocumentTitle('New Organization Form');
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onOrganizationCreated = () => {
    navigate('/organizations');
  };

  const { onSubmit, error, isPending } = useMutateOrganizationHandler({ onSuccess: onOrganizationCreated });

  useEffect(() => {
    if (!isPending && isSubmitting) {
      setIsSubmitting(false);
    }
  }, [isPending, isSubmitting]);

  const handleSubmit = async (payload) => {
    onSubmit(payload, false);
  };

  const handleCancel = async () => navigate('/organizations');

  return (
    <Stack direction="column" sx={{ mt: '-2rem' }}>
      <OrganizationForm
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        initialData={{ id: '', name: '', email: '', contact_emails: [], partner_id: '' }}
        apiErrors={error}
        isLoading={isPending || isSubmitting}
      ></OrganizationForm>
    </Stack>
  );
};

export default OrganizationCreatePage;
